import moment from 'moment';

/**
 * Constructs form data objects for whatever
 */
class FormData {
    constructor(data, token) {
        this.componentData = data;
        this.dateFormat = 'DD.MM.YYYY';
        if (token) {
            this.componentData.token = token;
        } else {
            this.componentData.token = null;
        }
    }

    parseBookingData() {
        let mDate = moment(this.componentData.selectedDate);
        let parsedData = {
            eventDate: mDate.format(this.dateFormat),
            audienceName: this.componentData.selectedAudience.name,
            venueName: this.componentData.venue,
            clientContact: {
                name: this.componentData.name,
                email: this.componentData.email,
                phone: this.componentData.phone
            },
            city: {
                citySlug: this.componentData.selectedCity.slug
            },
            audience: {
                audienceSlug: this.componentData.selectedAudience.slug
            },
            crowd: {
                slug: this.componentData.selectedCrowd.slug
            },
            venue: {
                venueName: this.componentData.venue
            },
            btbSource: {
                slug: 'btb'
            },
            message: this.componentData.message
        };

        return parsedData;
    }

    parseSearchData() {
        const prefix = 'psf';
        let mDate = moment(this.componentData.selectedDate);
        let buildMap = {
            eventDate: mDate.format(this.dateFormat),
            location: this.componentData.selectedCity.name,
            cityId: this.componentData.selectedCity.id,
            crowdId: this.componentData.selectedCrowd.id,
            audienceId: this.componentData.selectedAudience.id,
            fetch: 1
        };

        // Advanced search params
        if (this.componentData.selectedGenres) {
            buildMap.genre = this.componentData.selectedGenres;
        }
        if (this.componentData.selectedBandType) {
            buildMap.bandTypeId = this.componentData.selectedBandType.id;
        }
        if (this.componentData.selectedSongType) {
            buildMap.songTypeId = this.componentData.selectedSongType.id;
        }

        let url = '/fi/search/?1';
        Object.entries(buildMap).forEach((([key, value]) => {
            if (Array.isArray(value)) {
                for (let i = 0; i < value.length; i += 1) {
                    if (typeof value[i] === 'object') {
                        url += `&${prefix}[${key}][]=${value[i].id}`;
                    } else {
                        url += `&${prefix}[${key}][]=${value[i]}`;
                    }
                }
            } else {
                url += `&${prefix}[${key}]=${value}`;
            }
        }));
        return url;
    }

    parseQuoteReplyData() {
        let parsedData = {
            message: this.componentData.message,
            action: this.componentData.action
        };
        if (this.componentData.selectedTurnDownReason && this.componentData.selectedTurnDownReason.id) {
            parsedData.turnDownReason = this.componentData.selectedTurnDownReason.id;
        }
        return parsedData;
    }

    parseSignupData(component) {
        let componentData = component.$data;
        let parsedData = {
            user: {
                givenName: componentData.firstname,
                familyName: componentData.lastname,
                username: component.email,
                phone: componentData.phone
            }
        };
        if (componentData.invitation && componentData.invitation.id) {
            parsedData.invitationId = componentData.invitation.id;
            parsedData.invitationChecksum = component.$props.invitationChecksum;
        }
        parsedData = this.addToken(parsedData);
        return parsedData;
    }

    parseFeedbackData(component) {
        let componentData = component.$data;
        let parsedData = {
            name: componentData.name,
            email: component.email,
            message: componentData.message,
            subject: componentData.subject,
            url: this.componentData.url
        };
        parsedData = this.addToken(parsedData);
        return parsedData;
    }

    parseGigReviewData(component) {
        let componentData = component.$data;
        let parsedData = {
            text: componentData.message,
            points: componentData.points.id
        };
        parsedData = this.addToken(parsedData);
        return parsedData;
    }

    addToken(parsedData) {
        let dataWithToken = parsedData;
        if (this.componentData.token) {
            dataWithToken._token = this.componentData.token; // eslint-disable-line no-underscore-dangle
        }
        return dataWithToken;
    }
}

/**
 * FormData
 */
export default FormData;
